/**
 * Canonical same-origin API base for browser clients.
 *
 * Relative `/api` works with CRA's package.json proxy in development and with
 * nginx same-origin reverse-proxy routing in production (staging / zadruzbu).
 * Do not construct absolute `http://` API bases from window.location — that
 * produces Mixed Content on HTTPS pages.
 */
export const API_BASE_URL = "/api";
